module.exports = __webpack_public_path__ + "images/sgp/MediumStorage/10x30-Unit.webp";